import { incYenOf, incOf } from '../lib/pricing';
export const pricingHero = {
  title: '料金概要',
  titleEn: 'TUITION',
  lead: '受講料には、授業料のほか教材費・実習費・特典・認定試験料が含まれます。',
};

export const pricingCourses = [
  {
    id: 'essential',
    name: 'エッセンシャルコース',
    nameEn: 'ESSENTIAL COURSE',
    duration: '1ヶ月',
    days: '8日間',
    hours: '48時間',
    price: incYenOf('ac-essential'),
    schedule: '7月・1月開校',
  },
  {
    id: 'advanced',
    name: 'アドバンスコース',
    nameEn: 'ADVANCED COURSE',
    duration: '2ヶ月',
    days: '12日間',
    hours: '72時間',
    price: incYenOf('ac-advanced'),
    schedule: '5〜6月・11〜12月開校',
  },
  {
    id: 'master',
    name: 'マスターコース',
    nameEn: 'MASTER COURSE',
    duration: '3ヶ月',
    days: '16日間',
    hours: '96時間',
    price: incYenOf('ac-master'),
    schedule: '2〜4月・9〜11月開校',
  },
];

export const whatIncluded = [
  {
    label: '授業料',
    description: '全コース共通。経験豊富な講師陣による対面授業と実技指導。',
  },
  {
    label: '教材費',
    description: '協会監修の専門教科書。エッセンシャル5冊、アドバンス10冊、マスター15冊。',
  },
  {
    label: '実習費',
    description: 'スタジオでのロールプレイング実習。アドバンス・マスターコースでは、本物のサービスをゲストとして体験する特別実習を含みます。',
  },
  {
    label: '受講特典',
    description: '執事道具セット・白手袋・オーダーメイドベスト・修了生向けキャリア支援（準備中）など。',
  },
  {
    label: '修了実技試験料',
    description: '各コース修了時に実施する実技試験。合格者には協会認定資格を授与します。',
  },
  {
    label: '白手袋',
    description: '高品質な白手袋を全コースで標準支給。初日からサービス実習で着用します。',
  },
];

export const additionalCosts = [
  '銀行振込手数料はご負担ください。',
  'アドバンス・マスターの特別実習（サービス体験）における体験先までの交通費は各自ご負担となります。',
  '上記以外に追加のご負担が生じることは原則ありません。',
];

export const paymentMethod = {
  title: 'お支払い方法',
  titleEn: 'PAYMENT METHOD',
  lead: 'お支払いは、銀行振込による一括払いのみとさせていただいております。お振込先の口座情報は、お申込み後にお送りする受講契約のご案内に記載してお知らせします。分割払い・クレジットカードはご利用いただけません。',
  deadline: '開校日の14日前',
  notes: [
    '振込手数料はお客様負担でお願いいたします。',
    '入金確認をもって正式なお申込みとさせていただきます。',
    '分割払い・クレジットカードはご利用いただけません。',
  ],
};

export const transferDiscount = {
  title: '編入優遇',
  titleEn: 'TRANSFER DISCOUNT',
  lead: 'アドバンスはエッセンシャルの内容を、マスターはエッセンシャル・アドバンスの内容を含むため、修了済みの重複内容分を減額する優遇をご用意しています。段階的に学ぶほど、総額のご負担が軽くなります。',
  discounts: [
    {
      from: 'エッセンシャルコース',
      to: 'アドバンスコース',
      amount: '80,000',
      description: 'アドバンスはエッセンシャルの内容を含むため、エッセンシャル修了後にアドバンスへ進む場合、重複する内容分の受講料80,000円（税込）を減額します。',
    },
    {
      from: 'アドバンスコース',
      to: 'マスターコース',
      amount: '180,000',
      description: 'マスターはアドバンスの内容を含むため、アドバンス修了後にマスターへ進む場合、重複する内容分の受講料180,000円（税込）を減額します。',
    },
  ],
};

export const moreDetails = [
  {
    title: 'コース別料金詳細',
    description: 'コースごとの料金内訳をさらに詳しくご確認いただけます。',
    href: '/pricing/details',
  },
  {
    title: '受講特典',
    description: '実務で使える受講特典の詳細をご案内します。',
    href: '/benefits',
  },
  {
    title: '修了証・認定資格について',
    description: '修了で得られる協会認定資格の詳細をご確認ください。',
    href: '/certificate',
  },
];

export const pricingFaqs = [
  {
    question: '受講料はいくらですか?',
    answer: 'エッセンシャル780,000円、アドバンス1,180,000円、マスター1,680,000円（いずれも税込）です。',
  },
  {
    question: '料金には何が含まれますか?',
    answer: '授業料のほか、教材費・実習費・受講特典・修了実技試験料・白手袋が含まれます。追加のご負担は原則ありません。',
  },
  {
    question: '支払い方法は?',
    answer: '銀行振込による一括払いのみです。分割払い・クレジットカードはご利用いただけません。',
  },
  {
    question: '分割払いはできますか?',
    answer: '申し訳ございません。お支払いは銀行振込による一括払いのみで、分割払い・クレジットカードはご利用いただけません。お支払い期限は開校日の14日前です。',
  },
  {
    question: '編入優遇（割引）はありますか?',
    answer: 'はい。エッセンシャル修了後にアドバンスへ進む場合はアドバンス受講料から80,000円（税込）、アドバンス修了後にマスターへ進む場合はマスター受講料から180,000円（税込）を減額します。',
  },
  {
    question: '受講料以外にかかる費用はありますか?',
    answer: '銀行振込手数料はお客様のご負担となります。また、アドバンス・マスターの特別実習（本物のサービスを体験する実習）における体験先までの交通費は各自ご負担です。これら以外に追加のご負担が生じることは原則ありません。',
  },
  {
    question: 'コースはいつ開校しますか?',
    answer: 'エッセンシャルは7月・1月、アドバンスは5〜6月・11〜12月、マスターは2〜4月・9〜11月の開校を予定しています。いずれも土日開催で、1日6時間（90分×4コマ）の日程です。お申込みの締切は開校日の14日前です。',
  },
  {
    question: '定員や最少催行人数はありますか?',
    answer: '完全少人数制で、各コースの定員は最大6名です。最少催行人数は3名で、開校14日前までに3名に達しない場合は、受講料の全額返金、または次期への振替（5%優待付）をお選びいただけます。',
  },
];

export const pricingRelatedPages = [
  {
    title: 'コース別料金詳細',
    description: 'コースごとの料金内訳',
    href: '/pricing/details',
  },
  {
    title: '受講特典',
    description: '実務で使える受講特典',
    href: '/benefits',
  },
  {
    title: '修了証・認定資格について',
    description: '修了で得られる協会認定資格',
    href: '/certificate',
  },
  {
    title: 'コース一覧・比較',
    description: '3コースの違いを一覧で確認',
    href: '/courses',
  },
];